import { MapPin } from "lucide-react";
import { Reveal } from "./Reveal";
import BeforeAfter from "./BeforeAfter";

const GalleryJobCard = ({ job, index = 0 }) => (
    <Reveal delay={(index % 2) * 0.08}>
        <article className="group" data-testid={`gallery-job-${job.id}`}>
            <BeforeAfter job={job} />
            <div className="mt-4 flex flex-wrap items-baseline justify-between gap-x-6 gap-y-1">
                <h3 className="font-display font-black uppercase text-brand-cream text-2xl tracking-tight">
                    {job.title}
                </h3>
                {job.size && (
                    <span className="font-mono text-[11px] uppercase tracking-[0.2em] text-brand-amber">
                        {job.size}
                    </span>
                )}
            </div>
            {(job.location || job.note) && (
                <p className="mt-1 text-brand-sage text-sm leading-relaxed flex items-start gap-2">
                    {job.location && (
                        <span className="inline-flex items-center gap-1 text-brand-moss shrink-0">
                            <MapPin className="w-3.5 h-3.5" />
                            {job.location}
                        </span>
                    )}
                    {job.note && <span>{job.note}</span>}
                </p>
            )}
        </article>
    </Reveal>
);

export default GalleryJobCard;
